package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.PreMadeCharacter
import fr.manyverse.app.domain.model.PreMadeCharacterToCreate
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository
import fr.manyverse.app.domain.validation.CharacterSheetValidator
import fr.manyverse.app.domain.validation.CharacterValidator

class CreatePreMadeCharacterUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository
) {
    suspend operator fun invoke(
        preMadeCharacter: PreMadeCharacterToCreate
    ): Result<PreMadeCharacter> {
        CharacterValidator.validateForCreation(
            name = preMadeCharacter.name
        ).onFailure { return Result.failure(it) }

        preMadeCharacter.sheet.gauges.forEach { gauge ->
            CharacterSheetValidator
                .validateGauge(gauge.label, gauge.min, gauge.max, gauge.increment, gauge.current)
                .onFailure { return Result.failure(it) }
        }
        preMadeCharacter.sheet.characteristics.forEach { char ->
            CharacterSheetValidator.validateCharacteristic(char.label, char.value, char.description)
                .onFailure { return Result.failure(it) }
        }
        preMadeCharacter.sheet.skills.forEach { skill ->
            CharacterSheetValidator.validateSkill(skill.label, skill.description)
                .onFailure { return Result.failure(it) }
        }
        preMadeCharacter.sheet.powers.forEach { power ->
            CharacterSheetValidator.validatePower(power.label, power.description)
                .onFailure { return Result.failure(it) }
        }

        return preMadeCharacterRepository.createPreMadeCharacter(preMadeCharacter)
    }
}
